import { MongoDbLocation } from '@shared/types';
import { FunctionComponent, useCallback, useMemo } from 'react';
import styles from './styles.module.css';
import { useLocations } from '../../../../../../../hooks/useLocations';

export type LocationSelectProps = {
    id?: string;
    locationIds: Array<string>;
    value: string;
    onChange: (newValue: string) => any;
};

export const LocationSelect: FunctionComponent<LocationSelectProps> = ({
    id,
    locationIds,
    value,
    onChange,
}) => {
    const { data: locations = [], isLoading } = useLocations(locationIds, {
        keepPreviousData: true,
    });

    const handleChange = useCallback(
        (newValue: MongoDbLocation | null) => {
            onChange(newValue?._id || '');
        },
        [onChange]
    );

    const selectValue = useMemo(() => {
        return locations.find((location) => location._id === value);
    }, [locations, value]);

    const formatOptionLabel = useCallback((option: MongoDbLocation) => {
        return option.formatted.split('\n').join(', ');
    }, []);

    // TODO: Use whatever @cademy/ui select component we build
    // using a html select for just now

    if (isLoading) {
        return (
            <div className={styles.container}>
                <div className={styles.loading}>
                    <span>Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <select
                id={id}
                value={selectValue?._id}
                onChange={(e) => {
                    const value = e.target.value;
                    if (value === 'Select a location') {
                        return;
                    }
                    handleChange(
                        locations.find((location) => location._id === e.target.value) || null
                    );
                }}
            >
                <option>Select a location</option>
                {locations.map((location) => {
                    return (
                        <option key={location._id} value={location._id}>
                            {formatOptionLabel(location)}
                        </option>
                    );
                })}
            </select>
        </div>
    );
};
